import Restricted from '../../modules/restricted';

const RestrictedPage = () => {
  return <Restricted />;
};
export default RestrictedPage;
